import { Section } from "@/lib/puck/components/Section";
import { WithLayout, withLayout } from "@/lib/puck/components/Layout";
import { ComponentConfig } from "@measured/puck";
import getClassNameFactory from "@/lib/puck/get-class-name-factory";
import { levelOptions, sizeOptions } from "@/lib/puck/options";
import styles from "./styles.module.css";

export type HeadingProps = WithLayout<{
  align: "left" | "center" | "right";
  text?: string;
  level?: "1" | "2" | "3" | "4" | "5" | "6";
  size: "xxxxl" | "xxxl" | "xxl" | "xl" | "l" | "m" | "s" | "xs";
}>;

const HeadingInternal: ComponentConfig<HeadingProps> = {
  fields: {
    text: {
      type: "textarea",
      contentEditable: true,
    },
    size: {
      type: "select",
      options: sizeOptions,
    },
    level: {
      type: "select",
      options: levelOptions,
    },
    align: {
      type: "radio",
      options: [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" },
      ],
    },
  },
  defaultProps: {
    align: "left",
    text: "Heading",
    size: "s",
    layout: {
      padding: "8px",
    },
  },
  render: ({ align, text, size = "s", level }) => {
    const Tag: any = level ? `h${level}` : "span";
    const getClassName = getClassNameFactory("Heading", styles);

    return (
      <Section>
        <Tag
          className={getClassName({
            [size]: true,
          })}
        >
          <span style={{ display: "block", textAlign: align, width: "100%" }}>
            {text}
          </span>
        </Tag>
      </Section>
    );
  },
};

export const Heading = withLayout(HeadingInternal);
